export default __webpack_public_path__ + "static/media/nationalIdZA.89dae428.png";